export const SpecialWinTypeConfig = {
    minWinToBetRatio: 0,
    maxWinToBetRatio: 1,
    name: 'SpecialWinType',
    sounds: ['winSingle'],
    duration: 1,
    noCountUpAnimation: true
};
